class UltraCollection {
  constructor(sectionId) {
    this.container = document.getElementById(sectionId);
    if (!this.container) return;

    this.sectionId = sectionId.replace('ultra-', '');
    this.grid = document.getElementById('ProductGrid');
    this.loader = document.getElementById('InfiniteLoader');
    this.filterWrapper = this.container.querySelector('.ultra-col__filter-wrapper');
    this.activeCategory = sessionStorage.getItem('ultraColActiveCategory') || 'all';
    this.isLoading = false;

    // 1. Initialize ALL components
    this.initSmartSwipeForCards(); 
    this.initQuickView(); 
    this.initInfiniteScroll();
    
    this.initFilterListeners();
    this.hideSingleValueFilters(); 
    this.restoreFilterState(); 
    
    if (!window.ultraCollectionPopstateBound) {
       window.addEventListener('popstate', () => {
         this.fetchSection(window.location.href);
       });
       window.ultraCollectionPopstateBound = true;
     }

    let hasRefetched = false;
    const url = new URL(window.location.href);
    if (url.searchParams.get('filter.v.availability') !== '1') {
      url.searchParams.set('filter.v.availability', '1');
      window.history.replaceState(window.history.state, '', url.toString());
      this.fetchSection(url.toString());
      hasRefetched = true;
    }

    if (!hasRefetched && this.grid && this.grid.children.length === 0 && this.loader) {
      this.loadNextPage();
    }
  }

  initFilterListeners() {
    if (!this.filterWrapper) return;

    // 1. TOP TABS (Drawers) - Toggle Open/Close
    this.filterWrapper.addEventListener('click', (e) => {
        const catBtn = e.target.closest('.ultra-col__cat-btn');
        if (!catBtn) return;

        e.preventDefault();
        const groupName = catBtn.dataset.group;

        // "All" Tab Logic
        if (groupName === 'all') {
            if (this.activeCategory !== 'all') {
                this.setActiveCategory('all');
                const url = catBtn.dataset.url;
                if (url) this.updatePage(url);
            }
            return;
        }

        // Toggle Logic for Drawers
        if (this.activeCategory === groupName) {
            this.setActiveCategory('all'); // Close
        } else {
            this.setActiveCategory(groupName); // Open
        }
    });

    // 2. FILTER PILLS (Values) - Add/Remove Logic
    this.filterWrapper.addEventListener('click', (e) => {
        const valLink = e.target.closest('.ultra-col__val-pill');
        if (valLink) {
            e.preventDefault();

            // CHECK: Is this filter currently active?
            const isActive = valLink.classList.contains('active') || valLink.href === window.location.href;

            if (isActive) {
                // --- SURGICAL REMOVE LOGIC ---
                // We want to remove ONLY this specific value, preserving others.
                const currentUrl = new URL(window.location.href);
                const oldParams = currentUrl.searchParams;
                const newParams = new URLSearchParams(); 
                const valueText = valLink.innerText.trim();
                
                let foundMatch = false;

                // Loop through params to rebuild URL without the clicked filter
                for (const [key, value] of oldParams.entries()) {
                    // Check if this param matches the button text we want to remove
                    // (We check !foundMatch to only remove the first instance if duplicates exist)
                    if (!foundMatch && value === valueText) {
                        foundMatch = true;
                        continue; // Skip this one (delete it)
                    }
                    newParams.append(key, value);
                }

                if (foundMatch) {
                    currentUrl.search = newParams.toString();
                    this.updatePage(currentUrl.toString());
                } else {
                    // Fallback
                    const allBtn = this.filterWrapper.querySelector('[data-group="all"]');
                    if (allBtn && allBtn.dataset.url) {
                         this.updatePage(allBtn.dataset.url);
                    }
                }
            } else {
                // --- ADD LOGIC ---
                if (valLink.href) {
                    this.updatePage(valLink.href);
                }
            }
        }
    });
  }

  setActiveCategory(groupName) {
      this.activeCategory = groupName;
      sessionStorage.setItem('ultraColActiveCategory', groupName);
      this.restoreFilterState();
  }

  restoreFilterState() {
      if (!this.filterWrapper) return;
      
      const allBtns = this.filterWrapper.querySelectorAll('.ultra-col__cat-btn');
      const allGroups = this.filterWrapper.querySelectorAll('.ultra-col__value-group');

      // Reset visual state
      allBtns.forEach(btn => btn.classList.remove('active'));
      allGroups.forEach(g => g.hidden = true);

      // Activate correct tab
      if (this.activeCategory === 'all') {
          const allBtn = this.filterWrapper.querySelector('[data-group="all"]');
          if (allBtn) allBtn.classList.add('active');
      } else {
          const targetBtn = this.filterWrapper.querySelector(`[data-group="${this.activeCategory}"]`);
          const targetGroup = this.filterWrapper.querySelector(`#group-${this.activeCategory}`);
          
          if (targetBtn && targetBtn.style.display !== 'none') {
             targetBtn.classList.add('active');
             if (targetGroup) targetGroup.hidden = false;
          } else {
             this.activeCategory = 'all';
             const allBtn = this.filterWrapper.querySelector('[data-group="all"]');
             if (allBtn) allBtn.classList.add('active');
          }
      }
  }

  hideSingleValueFilters() {
    if (!this.filterWrapper) return;
    
    const groups = this.filterWrapper.querySelectorAll('.ultra-col__value-group');
    groups.forEach(group => {
       const count = group.querySelectorAll('.ultra-col__val-pill').length;
       const handle = group.id.replace('group-', '');
       const btn = this.filterWrapper.querySelector(`.ultra-col__cat-btn[data-group="${handle}"]`);
       
       if (btn) {
           const isFiltered = btn.classList.contains('has-active') || group.querySelector('.active');
           if (count <= 1 && !isFiltered) {
               btn.style.display = 'none';
               if (this.activeCategory === handle) {
                   this.activeCategory = 'all';
                   sessionStorage.setItem('ultraColActiveCategory', 'all');
               }
           } else {
               btn.style.display = '';
           }
       }
    });
  }

  // --- SCROLL TO RESULTS ---
  updatePage(url) {
      const pageUrl = new URL(url, window.location.origin);
      if (pageUrl.searchParams.get('filter.v.availability') !== '1') {
          pageUrl.searchParams.set('filter.v.availability', '1');
      }
      const finalUrl = pageUrl.toString();
      window.history.pushState({ path: finalUrl }, '', finalUrl);
      
      const grid = document.getElementById('ProductGrid');
      if(grid) {
          // Scroll to the start of the grid (minus offset for header)
          const gridTop = grid.getBoundingClientRect().top + window.scrollY;
          const targetPosition = gridTop - 200;
          
          window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
          });
      }

      this.fetchSection(finalUrl);
  }

  fetchSection(url) {
    if (this.grid) this.grid.classList.add('loading');
    
    const fetchUrl = new URL(url, window.location.origin);
    if (fetchUrl.searchParams.get('filter.v.availability') !== '1') {
      fetchUrl.searchParams.set('filter.v.availability', '1');
    }
    fetchUrl.searchParams.set('section_id', this.sectionId);
    
    // --- CACHE BUSTER (The Fix for Dependent Filters) ---
    // This forces Shopify to recalculate the available filters 
    // based on the current selection instead of serving a cached list.
    fetchUrl.searchParams.set('_', Date.now());

    fetch(fetchUrl)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.renderSection(html);
      })
      .catch(e => console.error(e));
  }

  renderSection(html) {
    const newGrid = html.getElementById('ProductGrid');
    const oldGrid = document.getElementById('ProductGrid');
    if (newGrid && oldGrid) {
      oldGrid.innerHTML = newGrid.innerHTML;
      oldGrid.classList.remove('loading');
    }

    const newFilters = html.querySelector('.ultra-col__filter-wrapper');
    const oldFilters = this.container.querySelector('.ultra-col__filter-wrapper');
    if (newFilters && oldFilters) {
      // 1. Swap HTML
      oldFilters.innerHTML = newFilters.innerHTML;
      
      // 2. Extra Cleanup: Hide disabled options if theme renders them
      const disabledInputs = oldFilters.querySelectorAll('input[disabled], .disabled');
      disabledInputs.forEach(input => {
          const pill = input.closest('.ultra-col__val-pill');
          if(pill) pill.style.display = 'none';
      });

      this.hideSingleValueFilters(); 
      this.restoreFilterState();
    }

    const newLoader = html.getElementById('InfiniteLoader');
    const oldLoader = document.getElementById('InfiniteLoader');
    if (newLoader && oldLoader) {
      oldLoader.dataset.nextUrl = newLoader.dataset.nextUrl || '';
      oldLoader.classList.remove('hidden');
      if (!newLoader.dataset.nextUrl) oldLoader.remove();
    } else if (newLoader && !oldLoader && newGrid) {
      const gridContainer = document.querySelector('.ultra-col__grid-container');
      gridContainer.appendChild(newLoader);
    } else if (!newLoader && oldLoader) {
      oldLoader.remove();
    }

    this.grid = document.getElementById('ProductGrid');
    this.loader = document.getElementById('InfiniteLoader');
    
    this.initSmartSwipeForCards(); 
    this.initQuickView(); 
    this.initInfiniteScroll();

    if (this.grid && this.grid.children.length === 0 && this.loader) {
      this.loadNextPage();
    }
  }

  // --- SmartSwipe ---
  initSmartSwipeForCards() {
    const cards = this.container.querySelectorAll('.ultra-col__card');
    cards.forEach(card => this.initCardSwipe(card));
  }

  initCardSwipe(card) {
    if (card.dataset.smartSwipeInit === 'true') return;
    card.dataset.smartSwipeInit = 'true';
    const track = card.querySelector('.ultra-col__slider-track');
    const slides = card.querySelectorAll('.ultra-col__slide');
    if (!track || slides.length <= 1) return;

    track.style.overflow = 'visible'; 
    let currentIndex = 0;
    let startX = 0;
    let isDragging = false;
    let isHorizontalSwipe = false;
    let isDirectionLocked = false;
    let isClickBlocked = false; 

    const updateSlide = (index, animate = true) => {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        currentIndex = index;
        const offset = -currentIndex * 100;
        track.style.transition = animate ? 'transform 0.3s cubic-bezier(0.25, 1, 0.5, 1)' : 'none';
        track.style.transform = `translateX(${offset}%)`;
        const dots = card.querySelectorAll('.ultra-col__dot');
        dots.forEach((d, i) => d.classList.toggle('active', i === currentIndex));
    };

    track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
        isDirectionLocked = false;
        isHorizontalSwipe = false;
        track.style.transition = 'none'; 
    }, { passive: true });

    track.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        const currentX = e.touches[0].clientX;
        const currentY = e.touches[0].clientY;
        const diffX = currentX - startX;
        if (!isDirectionLocked) {
            if (Math.abs(diffX) > 10 || Math.abs(currentY - e.touches[0].clientY) > 10) {
                isDirectionLocked = true;
                if (Math.abs(diffX) > Math.abs(currentY - e.touches[0].clientY)) isHorizontalSwipe = true;
            }
        }
        if (isHorizontalSwipe) {
            if (e.cancelable) e.preventDefault(); 
            e.stopPropagation();
            const slideWidth = track.offsetWidth;
            const currentOffset = -currentIndex * slideWidth;
            track.style.transform = `translateX(${currentOffset + diffX}px)`;
        }
    }, { passive: false });

    track.addEventListener('touchend', (e) => {
        if (!isDragging) return;
        isDragging = false;
        if (isHorizontalSwipe) {
            const endX = e.changedTouches[0].clientX;
            const diffX = endX - startX;
            if (diffX > 50) updateSlide(currentIndex - 1);
            else if (diffX < -50) updateSlide(currentIndex + 1);
            else updateSlide(currentIndex);
            e.stopPropagation();
        } else {
            updateSlide(currentIndex);
        }
    }, { passive: true });

    track.addEventListener('mousedown', (e) => {
        e.preventDefault(); 
        startX = e.clientX;
        isDragging = true;
        isDirectionLocked = true; 
        isHorizontalSwipe = true;
        isClickBlocked = false; 
        track.style.transition = 'none';
    });

    track.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        const diffX = e.clientX - startX;
        if (Math.abs(diffX) > 5) isClickBlocked = true;
        const slideWidth = track.offsetWidth;
        const currentOffset = -currentIndex * slideWidth;
        track.style.transform = `translateX(${currentOffset + diffX}px)`;
    });

    const endDrag = (e) => {
        if (!isDragging) return;
        isDragging = false;
        const diffX = e.clientX - startX;
        if (diffX > 50) updateSlide(currentIndex - 1);
        else if (diffX < -50) updateSlide(currentIndex + 1);
        else updateSlide(currentIndex);
    };

    track.addEventListener('mouseup', endDrag);
    track.addEventListener('mouseleave', endDrag);
    track.addEventListener('click', (e) => {
        if (isClickBlocked) {
            e.preventDefault();
            e.stopPropagation();
        }
    }, { capture: true });

    const arrows = card.querySelectorAll('.ultra-col__arrow');
    arrows.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const dir = btn.classList.contains('next') ? 1 : -1;
            updateSlide(currentIndex + dir);
        });
    });

    const dots = card.querySelectorAll('.ultra-col__dot');
    dots.forEach((dot, i) => {
        dot.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            updateSlide(i);
        });
    });
  }

  // --- QuickView (NATIVE FORM + COMMA FIX) ---
  initQuickView() {
    const btns = this.container.querySelectorAll('.quick-view-btn:not(.init)');
    const modal = document.getElementById('QuickViewModal');
    const mediaContainer = document.getElementById('QV-Media');
    const infoContainer = document.getElementById('QV-Info');

    btns.forEach(btn => {
      btn.classList.add('init');
      btn.addEventListener('click', (e) => {
        e.preventDefault(); 
        e.stopPropagation();
        
        const handle = btn.dataset.handle;
        if(modal) modal.classList.add('open');
        if(mediaContainer) mediaContainer.innerHTML = '<div style="padding:20px; text-align:center;">Loading...</div>';
        if(infoContainer) infoContainer.innerHTML = '';

        const rootUrl = window.Shopify.routes.root === '/' ? '' : window.Shopify.routes.root;
        fetch(`${rootUrl}/products/${handle}.js`) 
          .then(res => res.json())
          .then(product => {
            const imgUrl = product.featured_image || '';
            if(mediaContainer) mediaContainer.innerHTML = imgUrl ? `<a href="${product.url}" style="display:block; height:100%; width:100%;"><img src="${imgUrl}" class="ultra-col__modal-img"></a>` : '';

            const formatMoney = (cents) => {
                return (cents / 100).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
            };

            const price = formatMoney(product.price);
            const comparePrice = product.compare_at_price ? formatMoney(product.compare_at_price) : null;
            const currencySymbol = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : '';
            
            let priceHtml = `<div class="ultra-col__modal-price" style="margin-bottom:15px;">`; 
            if (comparePrice && parseFloat(comparePrice.replace(/,/g, '')) > parseFloat(price.replace(/,/g, ''))) {
                priceHtml += `<span style="text-decoration: line-through; opacity: 0.6; margin-right: 6px; font-weight: 400;">${currencySymbol} ${comparePrice}</span>`;
                priceHtml += `<span style="color: #B90000;">${currencySymbol} ${price}</span>`;
            } else {
                priceHtml += `${currencySymbol} ${price}`;
            }
            priceHtml += `</div>`;

            let variantsHtml = '';
            if(product.variants.length > 1) {
                variantsHtml = `<div class="ultra-col__variants" style="margin-top:15px; margin-bottom:15px;">`;
                product.variants.forEach((v, i) => {
                    variantsHtml += `<button type="button" class="ultra-col__variant-btn ${i===0?'active':''}" data-id="${v.id}" data-available="${v.available}">${v.title}</button>`;
                });
                variantsHtml += `</div>`;
            }

            const uniqueId = `qv-${Date.now()}`;
            const isInitialAvailable = product.variants && product.variants.length > 0 ? product.variants[0].available : true;
            const html = `
              <h2 class="ultra-col__modal-title" style="margin-bottom: 10px;">${product.title}</h2>
              ${priceHtml}
              <div class="ultra-col__modal-desc" style="margin-bottom:20px;">${product.description.replace(/(<([^>]+)>)/gi, "").substring(0, 150)}... <a href="${product.url}" style="text-decoration:underline; font-weight:600;">See full details &rarr;</a></div>
              
              <product-form class="product-form">
                  <div class="product-form__error-message-wrapper" role="alert" hidden><span class="product-form__error-message"></span></div>
                  
                  <form method="post" action="/cart/add" id="${uniqueId}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                      <input type="hidden" name="form_type" value="product">
                      <input type="hidden" name="utf8" value="✓">
                      <input type="hidden" name="id" value="${product.variants[0].id}">
                      
                      ${variantsHtml}

                      <button type="submit" name="add" class="ultra-col__modal-add"${!isInitialAvailable ? ' disabled' : ''}>
                          <span>${isInitialAvailable ? 'Add to Cart' : 'Sold Out'}</span>
                          <div class="loading__spinner hidden">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" style="width:20px;height:20px;"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>
                          </div>
                      </button>
                  </form>
              </product-form>
            `;
            
            if(infoContainer) {
                infoContainer.innerHTML = html;
                
                const variantButtons = infoContainer.querySelectorAll('.ultra-col__variant-btn');
                const idInput = infoContainer.querySelector('input[name="id"]');
                const submitBtn = infoContainer.querySelector('.ultra-col__modal-add');
                const submitBtnSpan = submitBtn ? submitBtn.querySelector('span') : null;

                variantButtons.forEach(btn => {
                    btn.addEventListener('click', () => {
                        variantButtons.forEach(b => b.classList.remove('active'));
                        btn.classList.add('active');

                        const variantId = btn.getAttribute('data-id');
                        if (idInput) {
                            idInput.value = variantId;
                        }

                        const isAvailable = btn.getAttribute('data-available') === 'true';
                        if (submitBtn) {
                            if (!isAvailable) {
                                submitBtn.disabled = true;
                                if (submitBtnSpan) {
                                    submitBtnSpan.textContent = 'Sold Out';
                                }
                            } else {
                                submitBtn.disabled = false;
                                if (submitBtnSpan) {
                                    submitBtnSpan.textContent = 'Add to Cart';
                                }
                            }
                        }
                    });
                });

                if(submitBtn) {
                   submitBtn.addEventListener('click', () => {
                       setTimeout(() => { if(modal) modal.classList.remove('open'); }, 800);
                   });
                }
            }
          })
          .catch(err => {
            if(infoContainer) infoContainer.innerHTML = '<p>Error loading product.</p>';
            console.error(err);
          });
      });
    });

    if(modal && !modal.dataset.bound) {
        modal.addEventListener('click', (e) => {
            if(e.target === modal) modal.classList.remove('open');
        });
        modal.dataset.bound = true;
    }
  }

  initInfiniteScroll() {
    if (!this.loader || !this.grid) return;
    if (this.observer) this.observer.disconnect();
    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !this.isLoading) {
        this.loadNextPage();
      }
    }, { rootMargin: '400px' });
    this.observer.observe(this.loader);
  }

  loadNextPage() {
    if (this.isLoading) return;
    const nextUrl = this.loader.dataset.nextUrl;
    if (!nextUrl) return;

    this.isLoading = true;
    this.loader.classList.add('visible');

    const fetchUrl = new URL(nextUrl, window.location.origin);
    if (fetchUrl.searchParams.get('filter.v.availability') !== '1') {
      fetchUrl.searchParams.set('filter.v.availability', '1');
    }
    fetchUrl.searchParams.set('section_id', this.sectionId);

    fetch(fetchUrl)
      .then(r => r.text())
      .then(data => {
        const parser = new DOMParser(); 
        const doc = parser.parseFromString(data, 'text/html');
        const newItems = doc.querySelectorAll('.ultra-col__card');
        const newNext = doc.getElementById('InfiniteLoader');
        
        let addedCount = 0;
        newItems.forEach(item => {
          this.grid.appendChild(item);
          addedCount++;
        });
        
        this.initSmartSwipeForCards(); 
        this.initQuickView(); 

        if (newNext && newNext.dataset.nextUrl) { 
          this.loader.dataset.nextUrl = newNext.dataset.nextUrl; 
          this.loader.classList.remove('visible'); 
          if (addedCount === 0) {
             this.isLoading = false;
             this.loadNextPage();
             return;
          }
        } else { 
          this.loader.remove(); 
        }
        this.isLoading = false;
      })
      .catch(e => {
        console.error("Infinite Scroll Error:", e);
        this.isLoading = false;
      });
  }
}

window.UltraCollection = UltraCollection;